const preUrl = 'https://app.wjjya.com'
// 接口地址
let apiUrl = {
	infoList: '/api/list',
	infoDetail: '/api/info',
	indexInfo: '/api/index',
	apply: '/api/record',
	infoSearch: '/api/search',
	normalUpload: '/api/upload',
	userInfo: '/api/user',
	list:  '/api/wishes/list',
    save:  '/api/wishes/save',
    upload:  '/api/base64/upload',
	blobUpload:  '/api/blob/upload',
	videoList: '/api/video/share/list',
	wishList: '/api/wish/list',
	wishSubmit: '/api/wish/update',
    getWechatConfig: preUrl + '/api/wechat/jssdk/share/url',
}
export {
	apiUrl
}


// WEBPACK FOOTER //
// ./src/assets/js/config.js